import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';

import { Container,GreySpan, ListOption } from './styles';

/**
 * Componente que verifica a força de uma senha com base em critérios específicos.
 * @param {object} props - Propriedades do componente.
 * @param {object} props.passwords - Objeto contendo as senhas e informações de confirmação.
 * @param {string} props.passwords.password - A senha a ser verificada.
 * @param {string} props.passwords.passwordConfirmation - A senha de confirmação, se disponível.
 * @param {boolean} props.passwords.isPasswordsMatchs - Indica se as senhas correspondem (opcional).
 * @param {(isValid: boolean) => void} props.onValid - Função de retorno de chamada para indicar se a senha é válida.
 * @returns {JSX.Element} O componente de verificação de senha.
 */
const CheckPasswords = ({ passwords, onValid }) => {
	const [passwordLength, setPasswordLength] = useState(0);
	const [validLength, setValidLength] = useState(false);
	const [hasNumber, setHasNumber] = useState(false);
	const [upperCase, setUpperCase] = useState(false);
	const [lowerCase, setLowerCase] = useState(false);
	const [specialChar, setSpecialChar] = useState(false);
	const [match, setMatch] = useState(false);

	useEffect(() => {
		const { password, passwordConfirmation, isPasswordsMatchs } = passwords;
		setPasswordLength(password.length);
		if (password.length === 0) return;
		setValidLength(password.length >= 8 ? true : false);
		setUpperCase(password.toLowerCase() !== password);
		setLowerCase(password.toUpperCase() !== password);
		setHasNumber(/\d/.test(password));
		setSpecialChar(/[`!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(password));
		if (passwordConfirmation) {
			setMatch(password === passwordConfirmation);
		}

		if (validLength && hasNumber && upperCase && lowerCase && specialChar && (isPasswordsMatchs || match)) {
			onValid?.(true);
		} else {
			onValid?.(false);
		}
	}, [passwords, onValid, validLength, hasNumber, upperCase, lowerCase, specialChar, match]);

	const checkField = (fieldValue) => {
		return passwordLength > 0 ? <span>{fieldValue ? <CheckIcon /> : <CloseIcon />}</span> : null;
	};

	return (
		<Container>
			<GreySpan>A senha deve conter, no mínimo:</GreySpan>
			<ul>
				<ListOption valid={validLength}>
					{checkField(validLength)}
					<span>8 ou mais caracteres</span>
				</ListOption>

				<ListOption valid={upperCase}>
					{checkField(upperCase)}
					<span>Letra maiúscula</span>
				</ListOption>

				<ListOption valid={lowerCase}>
					{checkField(lowerCase)}
					<span>Letra minúscula</span>
				</ListOption>

				<ListOption valid={hasNumber}>
					{checkField(hasNumber)} <span>Número</span>
				</ListOption>

				<ListOption valid={specialChar}>
					{checkField(specialChar)}
					<span>
            Caractere especial<span aria-hidden>(ex: #!*-_&)</span>
					</span>
				</ListOption>
			</ul>
		</Container>
	);
};

export default CheckPasswords;
